var localeValues = {
  "locale": "ht",
  "Pagination": {
    "items_per_page": "/paj",
    "jump_to": "Ale nan",
    "jump_to_confirm": "konfime",
    "page": "Paj",
    "prev_page": "Paj anvan an",
    "next_page": "Paj pwochen",
    "prev_5": "5 Paj anvan an",
    "next_5": "5 Paj powchen",
    "prev_3": "Paj anvan an",
    "next_3": "3 Paj pwochen",
    //@ts-ignore
    "page_size": "Dimansyon paj"
  },
  "DatePicker": {
    "lang": {
      "placeholder": "Chwazi dat",
      "yearPlaceholder": "Chwazi ane",
      "quarterPlaceholder": "Chwazi trimès",
      "monthPlaceholder": "Chwazi mwa",
      "weekPlaceholder": "Chwazi semen",
      "rangePlaceholder": ["Dat Kòmansman", "Dat Finisman"],
      "rangeYearPlaceholder": ["Ane Kòmansman", "Ane Finisman"],
      "rangeQuarterPlaceholder": ["Kòmansman trimès", "Fen trimès"],
      "rangeMonthPlaceholder": ["Mwa Kòmansman", "Mwa Finisman"],
      "rangeWeekPlaceholder": ["Semen Kòmansman", "Semen Finisman"],
      "locale": "en_US",
      "today": "Jodi a",
      "now": "Kounye a",
      "backToToday": "Retounen jodi a",
      "ok": "OK",
      "clear": "Efase",
      "month": "Mwa",
      "year": "Ane",
      "timeSelect": "chwazi tan",
      "dateSelect": "chwazi dat",
      "weekSelect": "Chwazi yon semèn",
      "monthSelect": "Chwazi yon mwa",
      "yearSelect": "Chwazi yon ane",
      "decadeSelect": "Chwazi yon dekad",
      "yearFormat": "AAAA",
      "dateFormat": "M/J/AAAA",
      "dayFormat": "J",
      "dateTimeFormat": "M / J / AAAA HH: mm: ss",
      "monthBeforeYear": true,
      "previousMonth": "Mwa anvan an (Paj moute)",
      "nextMonth": "Mwa pwochen (Paj desann)",
      "previousYear": "Ane pase a (Kontwòl + goche)",
      "nextYear": "Ane pwochèn (Kontwòl + dwa)",
      "previousDecade": "Dènye dekad la",
      "nextDecade": "Pwochen dekad la",
      "previousCentury": "Dènye syèk la",
      "nextCentury": "Pwochen syèk la"
    },
    "timePickerLocale": {
      "placeholder": "Chwazi tan",
      "rangePlaceholder": ["Lè Kòmansman", "Lè Finisman"]
    }
  },
  "TimePicker": {
    "placeholder": "Chwazi tan",
    "rangePlaceholder": ["Lè Kòmansman", "Lè Finisman"]
  },
  "Calendar": {
    "lang": {
      "placeholder": "Chwazi dat",
      "yearPlaceholder": "Chwazi ane",
      "quarterPlaceholder": "Chwazi trimès",
      "monthPlaceholder": "Chwazi mwa",
      "weekPlaceholder": "Chwazi semen",
      "rangePlaceholder": ["Dat Kòmansman", "Dat Finisman"],
      "rangeYearPlaceholder": ["Ane Kòmansman", "Ane Finisman"],
      "rangeQuarterPlaceholder": ["Kòmansman trimè", "Fen "],
      "rangeMonthPlaceholder": ["Mwa Kòmansman", "Mwa Finisman"],
      "rangeWeekPlaceholder": ["Semen Kòmansman", "Semen Finisman"],
      "locale": "en_US",
      "today": "Jodi a",
      "now": "Kounye a",
      "backToToday": "Retounen jodi a",
      "ok": "OK",
      "clear": "Efase",
      "month": "Mwa",
      "year": "Ane",
      "timeSelect": "chwazi tan",
      "dateSelect": "chwazi dat",
      "weekSelect": "Chwazi yon semèn",
      "monthSelect": "Chwazi yon mwa",
      "yearSelect": "Chwazi yon ane",
      "decadeSelect": "Chwazi yon dekad",
      "yearFormat": "AAAA",
      "dateFormat": "M/J/AAAA",
      "dayFormat": "J",
      "dateTimeFormat": "M / J / AAAA HH: mm: ss",
      "monthBeforeYear": true,
      "previousMonth": "Mwa anvan an (Paj moute)",
      "nextMonth": "Mwa pwochen (Paj desann)",
      "previousYear": "Ane pase a (Kontwòl + goche)",
      "nextYear": "Ane pwochèn (Kontwòl + dwa)",
      "previousDecade": "Dènye dekad la",
      "nextDecade": "Pwochen dekad la",
      "previousCentury": "Dènye syèk la",
      "nextCentury": "Pwochen syèk la"
    },
    "timePickerLocale": {
      "placeholder": "Chwazi tan",
      "rangePlaceholder": ["Lè Kòmansman", "Lè Finisman"]
    }
  },
  "global": {
    "placeholder": "Tanpri chwazi"
  },
  "Table": {
    "filterTitle": "Meni filtre",
    "filterConfirm": "OK",
    "filterReset": "Re-inisyalize",
    "filterEmptyText": "Okenn filtre",
    "filterCheckall": "Seleksyone tout ememan yo",
    "filterSearchPlaceholder": "Chèche nan filtè",
    "emptyText": "Pa gen done",
    "selectAll": "Chwazi paj aktyèl la",
    "selectInvert": "Envèse paj aktyèl la",
    "selectNone": "Efase tout done yo",
    "selectionAll": "Chwazi tout done yo",
    "sortTitle": "Klas",
    "expand": "Elaji ranje",
    "collapse": "Tonbe ranje",
    "triggerDesc": "Klike sou klas desandan",
    "triggerAsc": "Klike sou klas monte",
    "cancelSort": "Klike sou anile klasman"
  },
  "Modal": {
    "okText": "OK",
    "cancelText": "Anile",
    "justOkText": "OK"
  },
  "Popconfirm": {
    "okText": "OK",
    "cancelText": "Anile"
  },
  "Transfer": {
    "titles": ["", ""],
    "searchPlaceholder": "Chèche La a",
    "itemUnit": "atik",
    "itemsUnit": "atik (yo)",
    "remove": "Retire",
    "selectCurrent": "Chwazi paj aktyèl la",
    "removeCurrent": "Retire paj aktyèl la",
    "selectAll": "Chwazi tout done yo",
    "removeAll": "Retire tout done yo",
    "selectInvert": "Envèse paj aktyèl la"
  },
  "Upload": {
    "uploading": "Ap chaje",
    "removeFile": "Retire dosye a",
    "uploadError": "Erè nan téléchajman",
    "previewFile": "Apèsi dosye",
    "downloadFile": "Téléchaje dosye"
  },
  "Empty": {
    "description": "Pa gen done"
  },
  "Icon": {
    "icon": "icon"
  },
  "Text": {
    "edit": "Modifye",
    "copy": "Kopi",
    "copied": "Kopye",
    "expand": "Elaji"
  },
  "PageHeader": {
    "back": "Retou"
  },
  "Form": {
    "optional": "(pa obligatwa)",
    "defaultValidateMessages": {
      "default": "Erè nan validation domèn pou${label}",
      "required": "Tanpri antre${label}",
      "enum": "${label} dwe youn nan [${enum}]",
      "whitespace": "${label}pa ka yon karaktè vid",
      "date": {
        "format": "${label}fòma dat la valab",
        "parse": "${label}pa ka konvèti nan yon dat",
        "invalid": "${label}se yon dat ki pa valab"
      },
      "types": {
        "string": "${label}se pa yon valab ${type}",
        "method": "${label}se pa yon valab ${type}",
        "array": "${label}se pa yon valab ${type}",
        "object": "${label}se pa yon valab ${type}",
        "number": "${label}se pa yon valab ${type}",
        "date": "${label}se pa yon valab ${type}",
        "boolean": "${label}se pa yon valab ${type}",
        "integer": "${label}se pa yon valab ${type}",
        "float": "${label}se pa yon valab ${type}",
        "regexp": "${label}se pa yon valab ${type}",
        "email": "${label}se pa yon valab ${type}",
        "url": "${label}se pa yon valab ${type}",
        "hex": "${label}se pa yon valab ${type}"
      },
      "string": {
        "len": "${label}dwe ${len}karaktè",
        "min": "${label}dwe omwen ${min}karaktè",
        "max": "${label}dwe jiska ${max}karaktè",
        "range": "${label}dwe ant - karaktè${min}-${max}"
      },
      "number": {
        "len": "${label}dwe egal a${len}",
        "min": "${label}dwe minimòm${min}",
        "max": "${label} dwe maksimòm${max}",
        "range": "${label} dwe ant${min}-${max}"
      },
      "array": {
        "len": "Dwe${len} ${label}",
        "min": "Omwen${min} ${label}",
        "max": "Nan pifò${max} ${label}",
        "range": "${label}Kantite an nan dwe ant ${min}-${max}"
      },
      "pattern": {
        "mismatch": "${label} pa koresponn ak chema ${pattern}"
      }
    }
  },
  "Image": {
    "preview": "Apèsi"
  }
};
export default localeValues;